module.exports = __webpack_public_path__ + "static/media/1023496.2d1727c2.png";